export function removeDuplicate(arr) {
    return Array.from(new Set(arr));
}